import Backbone from 'backbone'
import template from './rest-communication-details.hbs'
import _ from 'lodash'
import hljs from 'highlight.js'
import {limitArrayItems} from './rest-data-selector'

const SUCCESS_BANNER = 'admin.import.datasource.from.rest.success'

const RestCommunicationDetails = Backbone.View.extend(/** @lends {RestCommunicationDetails} */{

	className: 'rest-communication-details',

	tagName: 'form',

	events: {
		'click .done': 'done'
	},

	/**
	 * Communication Details dialog for REST imports. Displays the request and
	 * response, HTTP status code, etc. See #50596, the section called
	 * "Testing the communication after Step 2" for details.
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Importable} options.model
	 */
	initialize: function(options = {}) {
		this.options = options
	},

	render: function() {
		let context = this.context()
		this.$el.html(template(context))
		this.highlightSyntax()

		let hasError = context.banner != SUCCESS_BANNER
		this.$('.banner').toggleClass('banner-error', hasError)
		this.$el.toggleClass('has-error', hasError)
		return this
	},

	context: function() {
		return _.extend({}, this.restMetadata(), {
			wsResponse: this.getLimitedWsResponse(),
			httpMethod: _.upperCase(this.restMetadata()?.httpMethod),
			title: this.options?.title ??
				'admin.import.datasource.from.rest.communicationDetails',
			banner: this.banner()
		})
	},

	getLimitedWsResponse: function() {
		const wsResponse = this.restMetadata()?.wsResponse
		try {
			const data = JSON.parse(wsResponse)
			return JSON.stringify(limitArrayItems(data))
		} catch (e) {
			return wsResponse
		}
	},

	/**
	 * Returns the i18n for the banner message.
	 */
	banner: function() {
		let banner = SUCCESS_BANNER
		let code = this.restMetadata()?.wsStatusCode
		if (code >= 200 && code <= 299) {
			try {
				JSON.parse(this.restMetadata()?.wsResponse)
			} catch (e) {
				return 'admin.import.datasource.from.rest.2xx.notJson'
			}
		}

		if (code >= 300 && code <= 399) {
			banner = 'admin.import.datasource.from.rest.3xx'
		}
		if (code >= 400 && code <= 499) {
			banner = 'admin.import.datasource.from.rest.4xx'
		}
		if (code >= 500 && code <= 599) {
			banner = 'admin.import.datasource.from.rest.5xx'
		}
		return banner
	},

	highlightSyntax: function() {
		_.each(this.$('pre, code:not(.status-line)'), el =>
			hljs.highlightElement(el))
	},

	/**
	 * Returns this.model.get('dataSourceMetadata')?.restMetadata
	 */
	restMetadata: function() {
		return this.model.get('dataSourceMetadata')?.restMetadata
	},

	done: function() {
		this.trigger('done')
	},

	autoRemove: true

})

export default RestCommunicationDetails

RestCommunicationDetails.__filename__ = 'imports/rest/rest-communication-details.js'
